import { createRoot } from "react-dom/client";
import "./index.css";
import { isWaitlistPath } from "../../shared/waitlist-links";

const root = createRoot(document.getElementById("root")!);
// Keep the Instagram conversion page independent of the heavy homepage,
// animations, popup and analytics initialization.
if (isWaitlistPath(window.location.pathname)) {
  const general = window.location.pathname.replace(/\/+$/, "") !== "/early-access";
  import("./pages/early-access").then(({ default: Page }) => root.render(<Page general={general} />));
} else {
  import("./App").then(({ default: App }) => root.render(<App />));
}
